"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllegroTransformOffPageConnectorGenerator = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const TransformNetLabel_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformNetLabel");
const TransformSchematic_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformSchematic");
const TransformSchematicDrawing_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformSchematicDrawing");
const allegroLayers_1 = require("../../../allegroLayers");
const LABEL_LAYER = allegroLayers_1.AllegroSchLayerMap[sigma_engine_shared_1.DesignModels.SchLayerType.Label].id;
const SYMBOL_LAYER = allegroLayers_1.AllegroSchLayerMap[sigma_engine_shared_1.DesignModels.SchLayerType.Symbol].id;
class AllegroTransformOffPageConnectorGenerator {
    constructor() {
        this.runsFor = [
            TransformSchematic_1.TransformSchematic,
        ];
    }
    *generate(schematic, rootContext) {
        const pageNum = schematic.instance.hierarchyEntry.loaded.pageNum;
        const design = rootContext.resolved.designs.find((d) => d.pageNum === pageNum);
        if (design === undefined) {
            return;
        }
        for (const symbolLabel of design.symbolLabels) {
            yield* emit(schematic, symbolLabel, design.defaultTextStyle);
        }
    }
}
exports.AllegroTransformOffPageConnectorGenerator = AllegroTransformOffPageConnectorGenerator;
function* emit(schematic, symbolLabel, textStyle) {
    const netLabel = new TransformNetLabel_1.TransformNetLabel(schematic, {
        position: symbolLabel.combobulatorAnchor,
        originalLabel: symbolLabel.labelText,
        labelType: 'system',
        strategyMetadata: symbolLabel.netName !== null ? { xconNetName: symbolLabel.netName } : undefined,
    }, labelDrawing(symbolLabel.labelText, symbolLabel.drawPosition, textStyle));
    yield netLabel;
    if (symbolLabel.groupDrawings.length > 0) {
        yield new TransformSchematicDrawing_1.TransformSchematicDrawing(schematic, {
            layers: [SYMBOL_LAYER],
            drawing: {
                type: 'group',
                pos: symbolLabel.groupOrigin,
                angle: 0,
                drawings: symbolLabel.groupDrawings,
            },
        }, netLabel);
    }
}
function labelDrawing(text, pos, style) {
    const attr = [];
    if (style.bold) {
        attr.push('bold');
    }
    if (style.italic) {
        attr.push('italic');
    }
    return {
        layers: [LABEL_LAYER],
        drawing: {
            type: 'text',
            value: text,
            pos,
            size: style.size,
            thickness: 1,
            justify: [-1, -1],
            ...(attr.length > 0 ? { attr } : {}),
            ...(style.color !== null ? { colorOverride: style.color } : {}),
        },
    };
}
//# sourceMappingURL=AllegroTransformOffPageConnectorGenerator.js.map